var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveredtoyourdoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9233 29.2225C25.0863 29.2225 25.2901 29.2225 25.4531 29.2225C26.8796 29.2225 28.0207 29.2225 28.9988 29.2643V17.3725C28.9988 17.0804 28.7543 16.8301 28.469 16.8301H24.8418C24.8826 16.9553 24.9233 16.997 24.9233 16.997V29.2225Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5684 31.8513L15.2642 31.6426C15.2235 31.6426 15.1827 31.6009 15.142 31.5592C15.1012 31.5174 15.1012 31.4757 15.1012 31.3923L15.3865 30.3491V30.3074L15.4273 30.1405C15.5088 29.765 15.7941 29.5146 16.1201 29.4312C17.465 29.2225 19.7066 29.0974 22.7632 29.0556V16.997C22.7632 16.997 22.7632 16.9135 22.7224 16.8301H14.4491C14.4084 16.9553 14.4084 16.997 14.4084 16.997V33.562H12.2891V16.997C12.2891 16.997 12.3299 16.9135 12.3706 16.8301H9.02871C8.5804 16.8301 8.17285 17.2056 8.17285 17.7063V32.8944C8.17285 33.3534 8.53965 33.7706 9.02871 33.7706H17.0167L16.5684 31.8513Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9232 29.055V16.9964C24.9232 16.9964 21.4997 7.56641 18.6061 7.56641C15.7125 7.56641 12.2891 16.9964 12.2891 16.9964V33.5614H14.4083V16.9964C14.4083 16.9964 16.4868 8.27574 18.6061 8.27574C20.7254 8.27574 22.8039 16.9964 22.8039 16.9964V29.055",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 31.4345L15.59 30.3496L17.8723 30.6417L18.0353 31.9352L15.3047 31.4345Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.826 31.4345L34.5 30.3496L32.2177 30.6417L32.0547 31.9352L34.826 31.4345Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5338 30.6406H17.8311L18.5646 35.3556C18.5646 35.5225 18.6869 35.606 18.8499 35.606L25.5338 35.6894L31.3618 35.606C31.484 35.606 31.6063 35.4808 31.647 35.3556L32.2584 30.6406H25.5338Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4592 30.1823C34.3777 29.8903 34.1739 29.6816 33.8886 29.6399C33.0735 29.5147 31.7286 29.2227 25.4523 29.2227C19.176 29.2227 16.9753 29.5147 16.1602 29.6399C15.8749 29.6816 15.6711 29.8903 15.5896 30.1823L15.5488 30.3492L17.8311 30.6413H25.5338H32.2177L34.5 30.3492L34.4592 30.1823Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4395 35.6477V30.6406H23.4553V35.606",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4395 29.3054V30.6406H23.4553V29.2637C22.2734 29.2637 21.2953 29.2637 20.4395 29.3054Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0548 31.9339L31.6064 35.272L32.2585 34.9799C32.4623 34.8547 32.6253 34.6461 32.6661 34.3957L33.3589 31.6836L32.0548 31.9339Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9131 31.0996L17.9946 31.9341L16.6904 31.6838L17.3833 34.3959C17.424 34.6463 17.587 34.8549 17.7908 34.9801L18.6059 35.3139L17.9131 31.0996Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9233 29.2225C25.0863 29.2225 25.2901 29.2225 25.4531 29.2225C26.8796 29.2225 28.0207 29.2225 28.9988 29.2643V17.3725C28.9988 17.0804 28.7543 16.8301 28.469 16.8301H24.8418C24.8826 16.9553 24.9233 16.997 24.9233 16.997V29.2225Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5684 31.8513L15.2642 31.6426C15.2235 31.6426 15.1827 31.6009 15.142 31.5592C15.1012 31.5174 15.1012 31.4757 15.1012 31.3923L15.3865 30.3491V30.3074L15.4273 30.1405C15.5088 29.765 15.7941 29.5146 16.1201 29.4312C17.465 29.2225 19.7066 29.0974 22.7632 29.0556V16.997C22.7632 16.997 22.7632 16.9135 22.7224 16.8301H14.4491C14.4084 16.9553 14.4084 16.997 14.4084 16.997V33.562H12.2891V16.997C12.2891 16.997 12.3299 16.9135 12.3706 16.8301H9.02871C8.5804 16.8301 8.17285 17.2056 8.17285 17.7063V32.8944C8.17285 33.3534 8.53965 33.7706 9.02871 33.7706H17.0167L16.5684 31.8513Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9232 29.055V16.9964C24.9232 16.9964 21.4997 7.56641 18.6061 7.56641C15.7125 7.56641 12.2891 16.9964 12.2891 16.9964V33.5614H14.4083V16.9964C14.4083 16.9964 16.4868 8.27574 18.6061 8.27574C20.7254 8.27574 22.8039 16.9964 22.8039 16.9964V29.055",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 31.4345L15.59 30.3496L17.8723 30.6417L18.0353 31.9352L15.3047 31.4345Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.826 31.4345L34.5 30.3496L32.2177 30.6417L32.0547 31.9352L34.826 31.4345Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5338 30.6406H17.8311L18.5646 35.3556C18.5646 35.5225 18.6869 35.606 18.8499 35.606L25.5338 35.6894L31.3618 35.606C31.484 35.606 31.6063 35.4808 31.647 35.3556L32.2584 30.6406H25.5338Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4592 30.1823C34.3777 29.8903 34.1739 29.6816 33.8886 29.6399C33.0735 29.5147 31.7286 29.2227 25.4523 29.2227C19.176 29.2227 16.9753 29.5147 16.1602 29.6399C15.8749 29.6816 15.6711 29.8903 15.5896 30.1823L15.5488 30.3492L17.8311 30.6413H25.5338H32.2177L34.5 30.3492L34.4592 30.1823Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4395 35.6477V30.6406H23.4553V35.606",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4395 29.3054V30.6406H23.4553V29.2637C22.2734 29.2637 21.2953 29.2637 20.4395 29.3054Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0548 31.9339L31.6064 35.272L32.2585 34.9799C32.4623 34.8547 32.6253 34.6461 32.6661 34.3957L33.3589 31.6836L32.0548 31.9339Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9131 31.0996L17.9946 31.9341L16.6904 31.6838L17.3833 34.3959C17.424 34.6463 17.587 34.8549 17.7908 34.9801L18.6059 35.3139L17.9131 31.0996Z",
    stroke: "black",
    strokeWidth: 0.8951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8041 33.7292C22.8041 33.6875 22.7634 33.6875 22.7226 33.6458L22.315 33.1868L22.7634 32.7278C22.8041 32.6861 22.8041 32.6861 22.8449 32.6444C22.8449 32.6026 22.8856 32.5609 22.8856 32.5192C22.8856 32.4774 22.8449 32.4357 22.8041 32.394C22.7634 32.3523 22.7226 32.3105 22.6818 32.3105C22.6411 32.3105 22.6003 32.3105 22.5596 32.3523C22.5188 32.3523 22.5188 32.394 22.4781 32.4357L22.0705 32.853L21.663 32.4357C21.6222 32.394 21.6222 32.394 21.5815 32.3523C21.5407 32.3523 21.4999 32.3105 21.4592 32.3105C21.4184 32.3105 21.3777 32.3523 21.3369 32.394C21.2962 32.4357 21.2554 32.4774 21.2554 32.5192C21.2554 32.5609 21.2554 32.6026 21.2962 32.6444C21.2962 32.6861 21.3369 32.6861 21.3777 32.7278L21.7852 33.1451L21.3369 33.604C21.2962 33.6458 21.2962 33.6458 21.2554 33.6875C21.2554 33.7292 21.2147 33.7709 21.2554 33.8127C21.2554 33.8544 21.2962 33.8961 21.3369 33.9378C21.3777 33.9796 21.4184 34.0213 21.4592 34.0213C21.4592 34.0213 21.4592 34.0213 21.4999 34.0213C21.5407 34.0213 21.5815 34.0213 21.5815 33.9796C21.6222 33.9796 21.6222 33.9378 21.663 33.8961L22.0705 33.4789L22.5188 33.8961C22.5596 33.9378 22.5596 33.9378 22.6003 33.9796C22.6411 33.9796 22.6818 34.0213 22.7226 34.0213C22.7634 34.0213 22.8041 33.9796 22.8449 33.9378C22.8856 33.8961 22.9264 33.8544 22.9264 33.8127C22.8449 33.8127 22.8449 33.7709 22.8041 33.7292Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8041 33.7292C22.8041 33.6875 22.7634 33.6875 22.7226 33.6458L22.315 33.1868L22.7634 32.7278C22.8041 32.6861 22.8041 32.6861 22.8449 32.6444C22.8449 32.6026 22.8856 32.5609 22.8856 32.5192C22.8856 32.4774 22.8449 32.4357 22.8041 32.394C22.7634 32.3523 22.7226 32.3105 22.6818 32.3105C22.6411 32.3105 22.6003 32.3105 22.5596 32.3523C22.5188 32.3523 22.5188 32.394 22.4781 32.4357L22.0705 32.853L21.663 32.4357C21.6222 32.394 21.6222 32.394 21.5815 32.3523C21.5407 32.3523 21.4999 32.3105 21.4592 32.3105C21.4184 32.3105 21.3777 32.3523 21.3369 32.394C21.2962 32.4357 21.2554 32.4774 21.2554 32.5192C21.2554 32.5609 21.2554 32.6026 21.2962 32.6444C21.2962 32.6861 21.3369 32.6861 21.3777 32.7278L21.7852 33.1451L21.3369 33.604C21.2962 33.6458 21.2962 33.6458 21.2554 33.6875C21.2554 33.7292 21.2147 33.7709 21.2554 33.8127C21.2554 33.8544 21.2962 33.8961 21.3369 33.9378C21.3777 33.9796 21.4184 34.0213 21.4592 34.0213C21.4592 34.0213 21.4592 34.0213 21.4999 34.0213C21.5407 34.0213 21.5815 34.0213 21.5815 33.9796C21.6222 33.9796 21.6222 33.9378 21.663 33.8961L22.0705 33.4789L22.5188 33.8961C22.5596 33.9378 22.5596 33.9378 22.6003 33.9796C22.6411 33.9796 22.6818 34.0213 22.7226 34.0213C22.7634 34.0213 22.8041 33.9796 22.8449 33.9378C22.8856 33.8961 22.9264 33.8544 22.9264 33.8127C22.8449 33.8127 22.8449 33.7709 22.8041 33.7292Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveredtoyourdoor);
export default __webpack_public_path__ + "static/media/deliveredtoyourdoor.7f2c8ac3ec084f2bc6b61cf3eb2c38fa.svg";
export { ForwardRef as ReactComponent };